/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * dead_link_api でリンク切れと判断された URL
 * @export
 * @interface DeadLink
 */
export interface DeadLink {
    /**
     * 対象の URL
     * @type {string}
     * @memberof DeadLink
     */
    url: string;
}

export function DeadLinkFromJSON(json: any): DeadLink {
    return DeadLinkFromJSONTyped(json, false);
}

export function DeadLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeadLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function DeadLinkToJSON(value?: DeadLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

